// src/routes/OnboardingRoutes.jsx
import React from "react";
import { Routes, Route } from "react-router-dom";
import AboutYou from "../features/ACS-Onboarding/MainOnboarding/AboutYou";
import FinalOnboarding from "../features/ACS-Onboarding/MainOnboarding/FinalOnboarding";
import CompanyInfo from "../features/ACS-Onboarding/MainOnboarding/CompanyInfo";
import InviteTeam from "../features/ACS-Onboarding/AddTeam/TeamDept";
import FTPLocation from "../features/ACS-Onboarding/AddTeam/FTPLocation";
import TeamOnboarding from "../features/ACS-Onboarding/AddTeam/TeamOnboarding";
import NotFoundPage from "../features/ACS-Auth/NotFoundPage";


const OnboardingRoutes = () => (
  <Routes>
    <Route path="about-you" element={<AboutYou />} />
    <Route path="company-info" element={<CompanyInfo />} />
    <Route path="final-onboard" element={<FinalOnboarding />} />
    <Route path="invite-team" element={<InviteTeam />} />
    <Route path="ftp-location" element={<FTPLocation />} />
    <Route path="team-onboard" element={<TeamOnboarding />} />
    <Route path="*" element={<NotFoundPage />} />
  </Routes>
);

export default OnboardingRoutes;
